/* eslint-disable */
import * as React from 'react';
import { default as ReactResizeDetector } from 'react-resize-detector';

const defaultStyle = {
  width: '100%',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
};

export const DetectableOverflow = props => {
  const { tag = 'div', children, onChange, style = defaultStyle, className = '' } = props;
  const [isOverflowed, setIsOverflowed] = React.useState(false);
  const elemRef = React.useRef(null);

  const updateState = () => {
    if (!elemRef) {
      return;
    }
    const isOverflowing =
      elemRef.current.offsetWidth !== elemRef.current.scrollWidth ||
      elemRef.current.offsetHeight !== elemRef.current.scrollHeight;
    setIsOverflowed(isOverflowing);
    if (typeof onChange === 'function') {
      onChange(isOverflowed);
    }
  };
  const attachRef = e => {
    if (typeof e === 'function') {
      elemRef(e);
    } else if (e !== null) {
      elemRef.current = e;
    }
  };

  React.useLayoutEffect(() => {
    updateState();
  });

  return React.createElement(
    tag,
    { style, className, ref: attachRef },
    <ReactResizeDetector handleWidth onResize={updateState} />,
    children
  );
};
